import { StepProgressProps } from "./StepProgress.types";

export const StepProgress = ({ totalSteps, currentStep, title, description }: StepProgressProps) => {
  const progressPercentage =
    totalSteps > 0 ? Math.min(100, Math.max(0, (currentStep / totalSteps) * 100)) : 0;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between text-sm font-medium text-gray-500">
        <span>
          Step <span className="text-gray-900">{currentStep}</span> of {totalSteps}
        </span>
        {/* Disabled save progress button for now */}
        {/* <button
          type="button"
          className="flex items-center gap-1 text-sm text-gray-500 transition-colors hover:text-gray-700"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
            />
          </svg>
          Save Progress
        </button> */}
      </div>

      <div className="h-2 w-full rounded-full bg-gray-200">
        <div
          className="h-2 rounded-full transition-all duration-300 ease-in-out"
          style={{ width: `${progressPercentage}%`, backgroundColor: "var(--theme-progress-bar-color, rgb(163 32 53 / var(--tw-bg-opacity, 1)))" }}
        />
      </div>

      <div className="space-y-2">
        <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>
        <p className="text-gray-600">{description}</p>
      </div>
    </div>
  );
};
